import api from './api';
import {
  setModules,
  setModulesLoading,
  setModuleTemplates
} from '../redux/actions/moduleActions';

export const getModulesWithTemplates = () => {
  return (dispatch, getState) => {
    dispatch(setModulesLoading());
    dispatch(getModuleTemplates());
    const templates = getState().moduleReducer.moduleTemplates;
    api.get(`/api/v1/modules`).then((modules) => {
      dispatch(
        setModules(
          modules.map((module) => {
            let template = templates.find(
              (temp) => temp.id === module.moduleTemplateId
            );
            return {
              ...module,
              template
            };
          })
        )
      );
    });
  };
};

export const getModuleTemplates = () => {
  return (dispatch) => {
    api.get(`/api/v1/module-templates`).then((templates) => {
      dispatch(setModuleTemplates(templates));
    });
  };
};

export const postModule = (moduleData) => {
  return api.put(`/api/v1/modules`, moduleData);
};
